import React from "react";
import Navbar2 from "../../Navbar/Navbar2/Navbar2";
import Footer from "../../Footer/Footer";
import { FaChartLine, FaTachometerAlt, FaThermometerHalf, FaBalanceScale, FaCogs } from "react-icons/fa";
import { BsPatchCheck } from "react-icons/bs";
import "./Upcoming2.css";

const Upcoming2 = ({ onNavigate }) => {
  return (
    <>
      <Navbar2 onNavigate={onNavigate} />
      <div className="upcoming2-section1">
        <div className="upcoming2-container">
          <h1 className="upcoming2-title">Shipshape Engine Performance™</h1>
          <h3 className="upcoming2-subtitle">
            Live Engine Insights. Better Performance. Lower Emissions.
          </h3>
          <p className="upcoming2-description">
            Shipshape Engine Performance™ delivers real-time insights into your
            vessel's engine condition, combustion quality, and power
            efficiency—fully integrated with the Shipshape Vessel Performance
            platform.
          </p>
          <button className="upcoming2-button" onClick={() => onNavigate('contact')}>Book Demo</button>
        </div>
      </div>

      <div className="upcoming2-section2">
        <h2 className="section2-heading">What It Measures</h2>
        <p className="section2-subheading">
          Comprehensive engine monitoring and diagnostics for optimal performance
        </p>
        <div className="measure-cards-grid">
          <div className="measure-card">
            <FaTachometerAlt className="measure-icon" />
            <h3>Indicative Power</h3>
            <p>
              Accurately calculates power produced by each cylinder and the entire engine
            </p>
          </div>
          <div className="measure-card">
            <FaThermometerHalf className="measure-icon" />
            <h3>Pmax (Peak Pressure)</h3>
            <p>
              Tracks combustion strength and ignition stability
            </p>
          </div>
          <div className="measure-card">
            <FaChartLine className="measure-icon" />
            <h3>Indicative Pressure Curves</h3>
            <p>
              Detects injector faults, scavenge inefficiencies, and valve timing issues
            </p>
          </div>
          <div className="measure-card">
            <FaBalanceScale className="measure-icon" />
            <h3>Engine Balance</h3>
            <p>
              Flags uneven load distribution and potential vibration sources
            </p>
          </div>
          <div className="measure-card">
            <FaCogs className="measure-icon" />
            <h3>Fuel-to-Power Efficiency</h3>
            <p>
              Benchmarks performance against real fuel consumption
            </p>
          </div>
        </div>
      </div>

{/* ----------------------------------- */}

      <div className="why-matters-container">
  <h2 className="why-matters-heading">Why It Matters</h2>
  <p className="why-matters-subheading">
    Transform your engine performance with actionable insights
  </p>

  <div className="why-matters-content">
    {/* Left Column */}
    <div className="why-column">
      <div className="why-item">
        <BsPatchCheck className="why-icon" />
        <div className="why-text">
          <h4>Accurate Indicative Power – Unit by Unit</h4>
          <p>
            See exactly what each unit is generating, enabling precise engine tuning and fault isolation.
          </p>
        </div>
      </div>

      <div className="why-item">
        <BsPatchCheck className="why-icon" />
        <div className="why-text">
          <h4>Avoid Emissions Penalties</h4>
          <p>
            Link power performance directly to fuel efficiency and CII/FuelEU/ETS compliance thresholds.
          </p>
        </div>
      </div>

      <div className="why-item">
        <BsPatchCheck className="why-icon" />
        <div className="why-text">
          <h4>Smarter Operational Decisions</h4>
          <p>
            Feed reliable engine intelligence into your routing, trim, and loading decisions via Shipshape Vessel and Voyage Performance.
          </p>
        </div>
      </div>
    </div>

    {/* Right Column */}
    <div className="why-column">
      <div className="why-item">
        <BsPatchCheck className="why-icon" />
        <div className="why-text">
          <h4>
            Improve Engine Efficiency
          </h4>
          <p>
            
              Eliminate hidden power losses due to fuel delivery, timing drift, or combustion anomalies.
            
          </p>
        </div>
      </div>

      <div className="why-item">
        <BsPatchCheck className="why-icon" />
        <div className="why-text">
          <h4>
            Predictive Maintenance
          </h4>
          <p>
            
              Detect faults early—before alarms trigger—based on live pressure data and pattern deviation.
            
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

{/* ----------------------------------------------- */}


<div className="ecosystem-container">
  <h2 className="ecosystem-heading">Ecosystem Integration</h2>
  <p className="ecosystem-subheading">
    Shipshape Engine Performance™ integrates seamlessly with your existing systems
  </p>

  <div className="ecosystem-card-grid">
    <div className="ecosystem-card">
      <h4>Shipshape Vessel Performance</h4>
      <p>Real-time engine diagnostics within your vessel’s live data ecosystem</p>
    </div>
    <div className="ecosystem-card">
      <h4>Shipshape Voyage Performance</h4>
      <p>Route-specific power analysis, trim guidance, and fuel impact modelling</p>
    </div>
    <div className="ecosystem-card">
      <h4>Shipshape Emissions Reporting & Compliance</h4>
      <p>MRV, CII, ETS-ready reporting with live penalty avoidance</p>
    </div>
    <div className="ecosystem-card">
      <h4>Shipshape ThrustPower™</h4>
      <p>Real-time thrust & torque analytics</p>
    </div>
    {/* <div className="ecosystem-card">
      <h4>Your Existing Systems</h4>
      <p>PMS, automation, or control systems integration</p>
    </div> */}
     <div className="ecosystem-card">
      <h4>Your Existing Systems</h4>
      <p>Seamless connectivity with operational, maintenance, and fleet management platforms</p>
    </div>
  </div>
</div>



{/* --------------------------------------------- */}

{/* 
<div className="intelligence-section">
  <div className="intelligence-card ai-card">
    <div className="intelligence-inner">
      <h3>AI-Powered Engine Intelligence</h3>
      <p>
        Each cylinder's pressure and performance data is processed through our AI engine to:
      </p>
      <ul>
        <li>Calculate accurate real-time indicative power</li>
        <li>Detect abnormal patterns or mechanical drift</li>
        <li>Compare against baseline & historical voyage data</li>
        <li>Trigger alerts for efficiency losses or imbalance</li>
        <li>Feed live performance metrics into routing and emissions tools</li>
      </ul>
    </div>
  </div>

  <div className="intelligence-card retrofit-card">
    <div className="intelligence-inner">
      <h3>Retrofit-Friendly Installation</h3>
      <p>
        Install during scheduled maintenance or drydock—no shaftline or crankshaft modification needed.
      </p>
      <p><strong>Compatible with:</strong></p>
      <ul>
        <li>MAN B&W 2-stroke engines</li>
        <li>Wärtsilä low-speed engines</li>
        <li>Older vessels without digital pressure diagnostics</li>
      </ul>
    </div>

    <div className="compatibility-note">
      <strong>Works With Your Current System</strong>
      <p>
        No software replacement needed. Shipshape Engine Performance™ operates
        on top of your existing infrastructure.
      </p>
    </div>
  </div>
</div> */}

<div className="intelligence-section">
  <div className="intelligence-card ai-card">
    <div className="intelligence-inner">
      <h3>AI-Powered Engine Intelligence</h3>
      <p>
        Operational and performance data is analyzed through our AI engine to:
      </p>
      <ul>
        <li>Generate real-time performance insights and operational benchmarks</li>
        <li>Detect anomalies, inefficiencies, and emerging performance trends</li>
        <li>Compare current performance against historical operational benchmarks</li>
        <li>Trigger alerts for efficiency losses, deviations, or operational risks</li>
        <li>Integrate performance insights into voyage optimization and emissions management workflows</li>
      </ul>
    </div>
  </div>

  <div className="intelligence-card retrofit-card">
    <div className="intelligence-inner">
      <h3>Flexible Deployment & Integration</h3>
      <p>
      Deploy quickly within your existing operational environment without disrupting established workflows.
      </p>
      <p><strong>Compatible with:</strong></p>
      <ul>
        <li>Existing fleet management platforms</li>
        <li>Voyage optimization solutions</li>
        <li>Emissions and compliance systems</li>
        <li>Operational and performance data sources</li>
      </ul>
    </div>

    <div className="compatibility-note">
      <strong>Works With Your Current System</strong>
      <p>
         No platform replacement required. Shipshape Engine Performance™ integrates with your existing systems and data environment to enhance visibility and decision-making.
      </p>
    </div>
  </div>
</div>



{/* ------------------------------------------------ */}


<div className="engine-performance-cta">
  <h2>Ready to Put Your Engine on the Performance Map?</h2>
  <p>
    Shipshape Engine Performance™ gives you the live engine intelligence you need to optimise voyages, 
    avoid penalties, and reduce costs. It brings the depth of traditional indicator cards, draw cards, 
    and manual timing checks into a smart, digital, always-on platform—fully integrated with Shipshape Vessel 
    and Voyage Performance.
  </p>
              <button className="cta-button" onClick={() => onNavigate('contact')}>Schedule Demo</button>
</div>


      <Footer onNavigate={onNavigate} />
    </>
  );
};

export default Upcoming2;
